export enum InventoryKitEnum {
  MALE_TSHIRT = "MALE_TSHIRT",
  FEMALE_CHEF_COAT = "FEMALE_CHEF_COAT",
  WINTER_JACKET = "WINTER_JACKET",
  RAIN_COAT = "RAIN_COAT",
  HAIR_NET = "HAIR_NET",
  MASK = "MASK",
  COD_CHEF_COAT = "COD_CHEF_COAT",
  APRON = "APRON",
}